<div class="status-dialog">

  <div class="dialog-header">

    <div class="title-wrap">

      <mat-icon class="header-icon">
        assignment_turned_in
      </mat-icon>

      <div>
        <h2>Update Requisition</h2>
        <p>Change requisition status and add comments</p>
      </div>

    </div>
    <button mat-icon-button class="close-btn" (click)="closeDialog()">

      <mat-icon>close</mat-icon>

    </button>

  </div>

  <div class="form-section">

    <mat-form-field appearance="outline">

      <mat-label>Status</mat-label>

      <mat-select [(value)]="status">

        <mat-option value="Open">
          Open
        </mat-option>

        <mat-option value="Confirmed">
          Confirmed
        </mat-option>

        <mat-option value="Sample collected">
          Sample Collected
        </mat-option>

        <mat-option value="Done">
          Done
        </mat-option>

      </mat-select>

    </mat-form-field>

    <mat-form-field appearance="outline">

      <mat-label>Lab Comments</mat-label>

      <textarea matInput rows="5" [(ngModel)]="comments">
      </textarea>

    </mat-form-field>

  </div>

  <div class="dialog-footer">

    <button mat-stroked-button class="cancel-btn" (click)="closeDialog()">

      Cancel

    </button>

    <button mat-raised-button color="primary" class="update-btn" (click)="update()">

      <mat-icon>check_circle</mat-icon>

      Update Status

    </button>

  </div>

</div>